<template>
	<div>
    <Update/>
    <Create/>
		<Read/>
	</div>
</template>

<script>
// @ is an alias to /src
import Read from '@/components/Category/Read.vue'
import Create from '@/components/Category/Create.vue'
import Update from '@/components/Category/Update.vue'

export default {
  name: 'category',
  components: {
    Read,
    Create,
    Update
  }
}
</script>
